import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\ReadinessAreaController::__invoke
* @see app/Http/Controllers/Investors/ReadinessAreaController.php:21
* @route '//app.finesthub.de/dashboard/readiness/{area}'
*/
const ReadinessAreaController = (args: { area: string | number } | [area: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: ReadinessAreaController.url(args, options),
    method: 'patch',
})

ReadinessAreaController.definition = {
    methods: ["patch"],
    url: '//app.finesthub.de/dashboard/readiness/{area}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Investors\ReadinessAreaController::__invoke
* @see app/Http/Controllers/Investors/ReadinessAreaController.php:21
* @route '//app.finesthub.de/dashboard/readiness/{area}'
*/
ReadinessAreaController.url = (args: { area: string | number } | [area: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { area: args }
    }

    if (Array.isArray(args)) {
        args = {
            area: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        area: args.area,
    }

    return ReadinessAreaController.definition.url
            .replace('{area}', parsedArgs.area.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\ReadinessAreaController::__invoke
* @see app/Http/Controllers/Investors/ReadinessAreaController.php:21
* @route '//app.finesthub.de/dashboard/readiness/{area}'
*/
ReadinessAreaController.patch = (args: { area: string | number } | [area: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: ReadinessAreaController.url(args, options),
    method: 'patch',
})

export default ReadinessAreaController